import React, { useEffect, useRef, useState } from "react";
import "../Styles/Travelers_favorite.css";
import RajasthanImage from "../Images/rajasthan_pic.png";
import api from "../Api.js";
import { useNavigate } from "react-router-dom";
import DateFormatter from "./Dateformatter";
import TourCardSkeleton from "./Helping Component/TourCardSkeleton.jsx";
import Skeleton from "@mui/material/Skeleton";


const SkeletonCard = () => {
  return (
    <div className="tf-card">
      <div className="tf-image">
        <Skeleton variant="rectangular" width="100%" height={220} />
      </div>

      <div className="tf-content">
        <Skeleton variant="text" width="80%" height={25} />
        <Skeleton variant="text" width="60%" height={20} />
        <Skeleton variant="text" width="90%" height={20} />

        <div className="tf-footer">
          <Skeleton variant="rectangular" width={100} height={35} />
          <Skeleton variant="text" width={120} height={20} />
        </div>
      </div>
    </div>
  );
};

function Travelers_favorite() {
  const [groupData, setGroupData] = useState([]);
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

useEffect(() => {
  const getAllGroupData = async () => {
    try {
      const response = await api.get("/tours/details?trip_type_id=5");
      console.log("the response from group tour are : ", response?.data);
      setGroupData(response?.data?.data || []);
    } catch (err) {
      console.log("Error fetching group tours");
    } finally {
      setIsLoading(false);
    }
  };
  getAllGroupData();
}, []);

  const scrollSlider = (direction) => {
    const scrollAmount = 420;
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: direction === "next" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

      // for url generation

const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};

const handleGroupDetails = (item)=>{
    const slug = createSlug(item?.tour?.title);

  const id = item?.tour?.id;

  const random = Math.floor(100 + Math.random() * 900); // random 3 digit 
  const encodedId = id + random;

  const urlPart = `${slug}-${encodedId}-${random}`;

  navigate(`/tour/grouptour/${urlPart}`);


}

  return (
    <section className="tf-wrapper">
      {/* Header */}
      <div className="tf-header">
        <h3>🔥 Trending Group Tours</h3>

        <div className="tf-actions">
          <button className="tf-nav-btn" onClick={() => scrollSlider("prev")}>
            ◀
          </button>

          <span
            className="tf-show-more"
            onClick={() => navigate("/tour/grouptour")}
          >
            + Show more
          </span>
                    <button className="tf-nav-btn" onClick={() => scrollSlider("next")}>
            ▶
          </button>
        </div>
      </div>

      {/* Slider */}
      <div className="tf-slider" ref={sliderRef}>
        {isLoading
  ? Array.from(new Array(6)).map((_, index) => (
      <SkeletonCard  key={index} />
    ))
  : groupData?.map((item, index) => (
          <div className="tf-card" key={index}>
            <div className="tf-image">
              <img
                src={
                  item?.tour?.images?.find((img) => img.is_featured)?.url ||
                  RajasthanImage
                }
                alt={item?.tour?.title}
              />
              <div className="tf-overlay">
                <h4>{item.tour.title}</h4>
                <span>
                  {item.tour.no_of_days} Days <br />
                  ₹{item.tour.raw_columns.mrp_group}
                </span>
              </div>
            </div>

            <div className="tf-content">
              <p>{item.tour.raw_columns.overview}</p>

              <div className="tf-footer">
                <button
                  onClick={()=>handleGroupDetails(item)}
                >
                  View Tour
                </button>

                <small>
                  Last Date:{" "}
                  <DateFormatter
                    dateString={item?.tour?.dates?.booking_end_date}
                  />
                </small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Travelers_favorite;
